export * as autocms from '@wix/auto_sdk_autocms-collection-metadata-service_autocms/meta';
